/** @format */

import axios from 'axios';

import { notification } from 'antd';

import { ENV_COUNTRY, ENV_FUNCTION_PANEL_TRACKING } from '../../hooks/enviroment';

import { AxiosAdapter } from '../../_config/adapters/axios/axios.adapter';
import { Http } from '../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export async function serviceCriterionQf(item) {
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_PANEL_TRACKING}/approve-register/judgment/${ENV_COUNTRY}`,
		data: {
			page: item.page,
			limit: 10,
			rut: item.rut,
			code_internal: item.code_internal,
			pharmacy: item.pharmacy,
		},
	})
		.then(async (response) => {
			if (response.data.statusCode === 200) {
				return response.data.data;
			} else {
				notification.error({
					message: response.error,
					description: response.message,
				});
				return { data: response.data };
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_PANEL_TRACKING}/approve-register/judgment/${ENV_COUNTRY}`,
			});
		});
}

export class Service {
	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
